import { Component } from '@angular/core';
import { AbstractFormWidgetComponent } from '../../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';
import { ResourceService } from 'sce-core';
import { NavigationService } from '../../../../../core/navigation.service';
import { AlertService } from 'sce-core';
import { UserService } from '../../../../../core/security/user.service';
import { LeftPanelService } from '../../../../../layout/home/services/left-panel.service';
import { DatePickerConfigService } from '../../../../../shared/components/datepicker/datepicker-config.service';

@Component({
  selector: 'lfwms-commodity-search',
  templateUrl: './commodity-otmCommodity-accordian.component.html',
  styleUrls: ['./commodity-otmCommodity-accordian.component.css']
})
export class  CommodityOTMAccordianComponent extends AbstractFormWidgetComponent {


  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected dateConfigService: DatePickerConfigService) {
      super(resourceService, navService, leftPanelService,
         alertService, userService, dateConfigService);
    }


}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/setup/customer/commodity/commodity-otmCommodity-accordian/commodity-otmCommodity-accordian.component.ts